module.exports = __webpack_public_path__ + "static/media/crypto_10k.43e6e306.avif";